'use client'

import { cn } from '@/lib/utils'
import { Fit, Layout, useRive } from '@rive-app/react-webgl2'
import { useEffect } from 'react'

interface RiveSpinnerProps {
  size?: number
  className?: string
}

export function RiveSpinner({ size = 64, className }: RiveSpinnerProps) {
  const { RiveComponent, rive } = useRive({
    src: '/animation/final-light.riv',
    stateMachines: 'State Machine 1',
    autoplay: true,
    layout: new Layout({ fit: Fit.Contain }),
  })

  useEffect(() => {
    if (rive) {
      rive.play()
    }
  }, [rive])

  useEffect(() => {
    return () => {
      if (rive) {
        rive.cleanup()
      }
    }
  }, [rive])

  return (
    <div
      className={cn('inline-flex items-center justify-center', className)}
      style={{ width: size, height: size }}
    >
      <RiveComponent />
    </div>
  )
}
